import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaPaperPlane,
} from "react-icons/fa";
import visitImage from "../assets/GH–HealthVillage.jpg";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: "", message: "" });

  // Google Apps Script URL - Replace with your deployed script URL
  const GOOGLE_APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxaqyIt0pmufgTFwsiwFUIpc3AHlV-hUOtzrEXpqJ2z_OuYgzW_HuRmakHXobxbwueZoQ/exec";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedback({ type: "", message: "" });

    try {
      // Validate required fields
      if (
        !formData.name ||
        !formData.email ||
        !formData.phone ||
        !formData.message
      ) {
        setFeedback({
          type: "error",
          message: "Please fill in all required fields.",
        });
        setLoading(false);
        return;
      }

      // Create FormData object for submission
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("phone", formData.phone);
      formDataToSend.append("subject", formData.subject);
      formDataToSend.append("message", formData.message);

      // Submit to Google Apps Script
      const response = await fetch(GOOGLE_APPS_SCRIPT_URL, {
        method: "POST",
        body: formDataToSend,
        mode: "no-cors",
      });

      // Push to Google Analytics dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "form_submit_success"
      });

      // Success feedback
      setFeedback({
        type: "success",
        message: "Thank you! Your message has been sent successfully.",
      });

      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });

      // Clear feedback after 5 seconds
      setTimeout(() => {
        setFeedback({ type: "", message: "" });
      }, 5000);
    } catch (error) {
      console.error("Form submission error:", error);
      setFeedback({
        type: "error",
        message: "An error occurred. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="bg-white">
      {/* HEADER */}
      <section className="py-16 text-center">
        <h1 className="text-4xl font-bold text-primary mb-4">
          Contact Information
        </h1>
        <p className="text-slate-600 max-w-2xl mx-auto">
          Get in touch with our team for any inquiries about our real estate
          projects. We’re here to assist you.
        </p>
      </section>

      {/* TOP CONTACT CARDS */}
      <section className="max-w-7xl mx-auto px-4 lg:px-8 grid md:grid-cols-3 gap-8 mb-20">
        {/* ADDRESS */}
        {/* ADDRESS */}
        <div className="text-center space-y-4">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary/10 text-primary">
            <FaMapMarkerAlt />
          </div>

          <h3 className="font-semibold">Office Address</h3>

          <p className="text-sm text-slate-600 leading-relaxed space-y-3">
            {/* Corporate Office */}
            <a
              href="https://www.google.com/maps?q=3rd%20Floor,%20Plot%20No.%2014,%20Lodha%20Road,%205th%20Phase,%20KPHB,%20Hyderabad"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:text-primary hover:underline transition"
            >
              <strong>Corporate Office (KPHB): </strong>
              3rd Floor, Plot No. 14, Lodha Road, 5th Phase, KPHB, Hyderabad –
              72
            </a>

            <br />

            {/* Banjara Hills */}
            <a
              href="https://www.google.com/maps?q=Plot%20No.%2077/4,%202nd%20Floor,%20MB%20Towers,%20Road%20No.%2010,%20Banjara%20Hills,%20Hyderabad"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:underline hover:text-primary transition"
            >
              <strong>Banjara Hills Branch: </strong>
              Plot No. 77/4, 2nd Floor, MB Towers, Road No. 10, Banjara Hills,
              Hyderabad – 34
            </a>

            <br />

            {/* LB Nagar */}
            <a
              href="https://www.google.com/maps?q=Plot%20No.%206,%20H%20No.%203-4-242,%20Srikari%20Heights,%20SBH%20Colony,%20L.B.%20Nagar,%20Hyderabad"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:underline hover:text-primary transition"
            >
              <strong>L.B. Nagar Branch: </strong>
              Plot No. 6, H No. 3-4-242, Srikari Heights, SBH Colony, L.B. Nagar
              Metro Station, L.B. Nagar, Hyderabad – 74
            </a>
          </p>
        </div>

        {/* PHONE */}
        <div className="text-center space-y-4">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary/10 text-primary">
            <FaPhoneAlt />
          </div>
          <h3 className="font-semibold">Phone & WhatsApp</h3>
          <p className="text-sm text-slate-600">
            WhatsApp: +91 83742 49705
            <br />
            Phone: +91 83319 05506
          </p>

          <a
            href="https://wa.me/918374249705"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-block bg-primary text-white px-5 py-2 rounded-md text-sm"
          >
            Chat on WhatsApp
          </a>
        </div>

        {/* EMAIL */}
        <div className="text-center space-y-4">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary/10 text-primary">
            <FaEnvelope />
          </div>
          <h3 className="font-semibold">Email Us</h3>
          <p className="text-sm text-slate-600">rameshgadhamv6@gmail.com</p>

          <a
            href="mailto:rameshgadhamv6@gmail.com"
            className="mt-3 inline-block bg-primary text-white px-5 py-2 rounded-md text-sm"
          >
            Send Email
          </a>
        </div>
      </section>

      {/* WORKING HOURS + FORM */}
      <section className="max-w-7xl mx-auto px-2 lg:px-8 grid lg:grid-cols-2 gap-14 mb-24">
        {/* LEFT */}
        <div className="space-y-12">
          {/* WORKING HOURS */}
          <div>
            <h3 className="font-bold text-xl text-primary mb-6">
              Working Hours
            </h3>

            <div className="grid grid-cols-2 gap-6 text-sm text-slate-600">
              <div>
                <p className="font-medium text-slate-800">Monday – Friday</p>
                <p>8:00 AM – 6:00 PM</p>
              </div>
              <div>
                <p className="font-medium text-slate-800">Saturday</p>
                <p>8:00 AM – 6:00 PM</p>
              </div>
              <div>
                <p className="font-medium text-slate-800">Sunday</p>
                <p>Closed</p>
              </div>
              <div>
                <p className="font-medium text-slate-800">Holidays</p>
                <p>By Appointment Only</p>
              </div>
            </div>
          </div>

          {/* SITE VISIT CTA */}
          <div>
            <h4 className="font-semibold text-lg mb-3">Site Visit Timings</h4>

            <p className="text-sm text-slate-600 mb-6 max-w-md">
              We offer guided site visits every day from 8:00 AM to 6:00 PM by
              appointment only.
            </p>

            <button className="w-full bg-primary text-white py-3.5 rounded-md font-medium shadow-sm hover:bg-primaryDark transition">
              Schedule a Site Visit
            </button>
          </div>
        </div>

        {/* FORM */}
        <div>
          <h3 className="font-bold text-xl text-primary mb-8">
            Send us a Message
          </h3>

          {/* FEEDBACK MESSAGE */}
          {feedback.message && (
            <div
              className={`mb-6 p-4 rounded-md text-sm font-medium ${
                feedback.type === "success"
                  ? "bg-green-100 text-green-800 border border-green-300"
                  : "bg-red-100 text-red-800 border border-red-300"
              }`}
            >
              {feedback.message}
            </div>
          )}

          <form className="grid grid-cols-2 gap-5" onSubmit={handleSubmit}>
            {/* NAME */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Your Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/30"
              />
            </div>

            {/* EMAIL */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Email Address <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/30"
              />
            </div>

            {/* PHONE */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Phone Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="phone"
                placeholder="Enter your phone number"
                value={formData.phone}
                onChange={handleInputChange}
                required
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/30"
              />
            </div>

            {/* SUBJECT */}
            <div className="col-span-1">
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Subject
              </label>
              <input
                type="text"
                name="subject"
                placeholder="Property inquiry"
                value={formData.subject}
                onChange={handleInputChange}
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/30"
              />
            </div>

            {/* MESSAGE */}
            <div className="col-span-2">
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                rows="1"
                name="message"
                placeholder="Your message here..."
                value={formData.message}
                onChange={handleInputChange}
                required
                className="w-full border rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/30"
              />
            </div>

            {/* SUBMIT */}
            <button
              type="submit"
              disabled={loading}
              className="col-span-2 bg-primary text-white py-3.5 rounded-md font-medium flex items-center justify-center gap-2 shadow-sm hover:bg-primaryDark transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FaPaperPlane className="text-sm" />
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </section>

      {/* ================= MAP SECTION ================= */}
      <section className="bg-white rounded-xl pt-10 pb-10 shadow-sm mb-10">
        <h3 className="text-center text-2xl font-bold text-primary mb-10">
          Our Office Locations
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Corporate Office – KPHB */}
          <div>
            <h4 className="text-center font-semibold mb-4">
              Corporate Office – KPHB
            </h4>

            <div className="h-[260px] rounded-lg overflow-hidden border">
              <iframe
                title="Corporate Office KPHB"
                src="https://www.google.com/maps?q=Aduri%20Infra%20Pvt%20Ltd,%20KPHB%205th%20Phase,%20Hyderabad&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
              />
            </div>

            <div className="text-center mt-4">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=3rd%20Floor,%20Plot%20No.%2014,%20Lodha%20Road,%205th%20Phase,%20KPHB,%20Hyderabad"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-primary font-medium hover:underline"
              >
                View on Google Maps
              </a>
            </div>
          </div>

          {/* Banjara Hills Branch */}
          <div>
            <h4 className="text-center font-semibold mb-4">
              Banjara Hills Branch
            </h4>

            <div className="h-[260px] rounded-lg overflow-hidden border">
              <iframe
                title="Banjara Hills Branch"
                src="https://www.google.com/maps?q=Aduri%20Group%20Banjara%20Hills%20Branch,%20Road%20No%2010,%20Hyderabad&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
              />
            </div>

            <div className="text-center mt-4">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Plot%20No.%2077/4,%202nd%20Floor,%20MB%20Towers,%20Road%20No.%2010,%20Banjara%20Hills,%20Hyderabad"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-primary font-medium hover:underline"
              >
                View on Google Maps
              </a>
            </div>
          </div>

          {/* LB Nagar Branch */}
          <div>
            <h4 className="text-center font-semibold mb-4">
              L.B. Nagar Branch
            </h4>

            <div className="h-[260px] rounded-lg overflow-hidden border">
              <iframe
                title="LB Nagar Branch"
                src="https://www.google.com/maps?q=Plot%20No.%206,%20H%20No.%203-4-242,%20Srikari%20Heights,%20SBH%20Colony,%20L.B.%20Nagar,%20Hyderabad&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
              />
            </div>

            <div className="text-center mt-4">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Plot%20No.%206,%20H%20No.%203-4-242,%20Srikari%20Heights,%20SBH%20Colony,%20L.B.%20Nagar,%20Hyderabad"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-primary font-medium hover:underline"
              >
                View on Google Maps
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-10 pb-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="bg-sky-100 rounded-3xl overflow-hidden grid lg:grid-cols-2 items-center">
            {/* LEFT CONTENT */}
            <div className="p-10 lg:p-14">
              <h2 className="text-3xl lg:text-4xl font-bold text-primary mb-6">
                Schedule a Site Visit
              </h2>

              <p className="text-slate-600 text-lg leading-relaxed mb-10 max-w-xl">
                Experience our project firsthand. Schedule a site visit at your
                convenient time and our representative will assist you.
              </p>

              <div className="flex flex-wrap gap-4">
                <button
                  onClick={() => navigate("/#site-visit")}
                  className="bg-primary text-white px-8 py-3 rounded-lg font-medium"
                >
                  Book Site Visit
                </button>

                <a
                  href="tel:+918374249705"
                  className="border border-primary text-primary px-8 py-3 rounded-lg font-medium hover:bg-white transition"
                >
                  Call Now
                </a>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="h-full">
              <img
                src={visitImage}
                alt="Schedule Site Visit"
                className="w-full h-full object-cover rounded-tr-3xl rounded-br-3xl"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
